module.exports = "/_next/static/images/6-1-98d6d3889e3c55f08220ed6e26377569.svg";